import React from 'react';

export default function LoadingPage() {
  return (
    <div className="loading-page">
      <div style={{
        width: 56, height: 56,
        background: 'linear-gradient(135deg, #3b82f6, #8b5cf6)',
        borderRadius: 16,
        display: 'flex', alignItems: 'center', justifyContent: 'center',
        fontSize: 28, marginBottom: 16,
        animation: 'pulse-dot 1.5s ease infinite'
      }}>🛡️</div>
      <div className="spinner" />
      <p>Loading RelationProtector...</p>
    </div>
  );
}
